// extracted by mini-css-extract-plugin
module.exports = {"promo":"_9330de7794--promo--zR4d2"};